// extracted by mini-css-extract-plugin
export default {"cls1":"ResearchInterestTags-cls1__d78dbef9f93d3f3c7bff","cls2":"ResearchInterestTags-cls2___31ca8b900aee537e292 ResearchInterestTags-cls1__d78dbef9f93d3f3c7bff"};